import {ENDPOINT_VERSIONS} from './_endpoint-versions';

export const UPLOAD_FILE_ENDPOINT = `/${ENDPOINT_VERSIONS.V2}/files`;

export const SET_FILES_TO_TICKETS_ENDPOINT = `/${ENDPOINT_VERSIONS.V2}/files/set-to-tickets`;

export const GET_FILES_GET_AVAILABLE_TICKETS_COUNT = `/${ENDPOINT_VERSIONS.V2}/tickets/available-ticket-count`;
